// extracted by mini-css-extract-plugin
export var list = "navigation-list-module--list--e0aIT";
export var borderList = "navigation-list-module--border-list--itJon";
export var navigationList = "navigation-list-module--navigation-list--Kzud8";